import ReactApexChart from "react-apexcharts";

//import { lineChartData, lineChartOptions } from "./variables/charts";

type Props = {
  graphData: any;
};

export const LineChart: any = ({ graphData }: Props) => {
  const lineChartData = [
    {
      name: "Количество запросов",
      data: [50, 40, 300, 220, 500, 250, 400, 230, 500],
    },
    {
      name: "Количество заключенных сделок",
      data: [30, 90, 40, 140, 290, 290, 340, 230, 400],
    },
  ];

  const lineChartOptions: any = {
    chart: {
      height: 500,
      type: "area",
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    xaxis: {
      //type: "datetime",
      categories: [
        "Янв",
        "Фев",
        "Мар",
        "Апр",
        "Май",
        "Июнь",
        "Июль",
        "Авг",
        "Сен",
        "Окт",
        "Ноя",
        "Дек",
      ],
      labels: {
        style: {
          colors: "#c8cfca",
          fontSize: "12px",
        },
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "vertical",
        shadeIntensity: 0.5,
        gradientToColors: undefined, // optional, if not defined - uses the shades of same color in series
        inverseColors: true,
        opacityFrom: 0.8,
        opacityTo: 0,
        stops: [],
      },
      colors: ["#4FD1C5", "#2D3748"],
    },
    yaxis: {
      labels: {
        style: {
          colors: "#c8cfca",
          fontSize: "12px",
        },
      },
    },
    legend: {
      show: true,
    },
    colors: ["#4FD1C5", "#2D3748"],
  };

  return (
    <ReactApexChart
      options={lineChartOptions}
      series={graphData == "single" ? [lineChartData[0]]: lineChartData}
      type="area"
      height={graphData == "single" ? 230: 450}
    />
  );
};
